import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  id: 'implantes',
  title: 'Implantes Dentales',
  desc: 'Restauración perfecta con tecnología 3D guiada para resultados definitivos y naturales.',
  img: 'https://cdn.magicpatterns.com/uploads/dLMHwiGc3cvLFpfaBLFA7C/Imagen_3.jpg'
}, {
  id: 'estetica',
  title: 'Estética Dental',
  desc: 'Carillas de porcelana ultrafinas diseñadas digitalmente para una sonrisa simétrica y deslumbrante.',
  img: 'https://cdn.magicpatterns.com/uploads/46ngsUNebdrHiT2eZr6vbT/Imagen_1.webp'
}, {
  id: 'ortodoncia',
  title: 'Ortodoncia Invisible',
  desc: 'Alineadores transparentes de última generación. Discretos, removibles y altamente efectivos.',
  img: 'https://cdn.magicpatterns.com/uploads/nKMouBBn84zpMoqK7t1cjm/Imagen_2.jpg'
}, {
  id: 'limpieza',
  title: 'Limpieza Profesional',
  desc: 'Terapia Airflow con agua y luz para una higiene profunda, indolora y blanqueamiento natural.',
  img: 'https://cdn.magicpatterns.com/uploads/c8KgjsQjL1XJQ4mZ9Va9WT/Imagen_3.jpg'
}];
export function Services() {
  return <section id="servicios" className="py-24 bg-sand relative z-20" data-id="element-91" data-mp="3b3zlkxqc5ml6">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-92" data-mp="2xcb9gug36y47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: [0.23, 1, 0.32, 1]
      }} className="mb-16" data-id="element-93" data-mp="2x9oqzzrnqy77">
          <h2 className="font-serif text-4xl md:text-5xl text-ink mb-4" data-id="element-94" data-mp="3g1hmq1y42xim">
            Nuestros Servicios{' '}
            <span className="text-gold-deep italic" data-id="element-95" data-mp="3kzj2acwbwepc">de Élite</span>
          </h2>
          <div className="w-24 h-1 bg-gold mb-6" data-id="element-96" data-mp="24mcginyrugu9"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-97" data-mp="29mqfzhmb4igo">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="group relative h-[450px] md:h-[500px] rounded-xl overflow-hidden cursor-pointer bg-surface border border-line hover:border-gold transition-[border-color,box-shadow,transform] duration-300 hover:shadow-[0_18px_40px_rgba(201,162,39,0.22)]" data-id="element-98" data-mp="1pj16xxlsdqrk" data-mpi={index}>
              <div className="w-full h-full flex flex-col" data-id="element-99" data-mp="sw6bxr4zr0cb">
                <div className="h-[70%] w-full overflow-hidden relative" data-id="element-100" data-mp="2s5mnh0mtbd78">
                  <img src={service.img} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-101" data-mp="2n7l3mdhkb9up" />
                </div>

                <div className="flex-1 p-8 flex flex-col justify-center" data-id="element-102" data-mp="2zo42fmdgjk7l">
                  <h3 className="font-serif text-2xl text-ink mb-2 group-hover:text-gold-deep transition-colors duration-300" data-id="element-103" data-mp="34hyq10w6ojby">
                    {service.title}
                  </h3>
                  <p className="font-sans text-ink-soft text-sm md:text-base leading-relaxed" data-id="element-104" data-mp="2bu2kr7sjtj3k">
                    {service.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}